var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 6C1.25 5.58579 1.58579 5.25 2 5.25H22C22.4142 5.25 22.75 5.58579 22.75 6V10C22.75 10.2634 22.6118 10.5076 22.3859 10.6431L21.6866 11.0627C20.3407 11.8702 18.6593 11.8702 17.3134 11.0627L17 10.8746L16.6866 11.0627C15.3407 11.8702 13.6593 11.8702 12.3134 11.0627L12 10.8746L11.6866 11.0627C10.3407 11.8702 8.65929 11.8702 7.31338 11.0627C7.31338 11.0627 7.31338 11.0627 7.31338 11.0627L7 10.8746L6.68663 11.0627C6.68662 11.0627 6.68663 11.0627 6.68663 11.0627C5.34072 11.8702 3.6593 11.8702 2.3134 11.0627C2.3134 11.0627 2.3134 11.0627 2.3134 11.0627L1.61413 10.6431C1.38823 10.5076 1.25 10.2634 1.25 10V6ZM2.75 6.75V9.57535L3.08513 9.77643C3.956 10.299 5.04399 10.299 5.91487 9.77643L6.61413 9.35688C6.85164 9.21437 7.14836 9.21437 7.38587 9.35688L8.08512 9.77643C8.95601 10.299 10.044 10.299 10.9149 9.77643L11.6141 9.35688C11.8516 9.21437 12.1484 9.21437 12.3859 9.35688L13.0851 9.77643C13.956 10.299 15.044 10.299 15.9149 9.77643L16.6141 9.35688C16.8516 9.21437 17.1484 9.21437 17.3859 9.35688L18.0851 9.77643C18.956 10.299 20.044 10.299 20.9149 9.77643L21.25 9.57536V6.75H2.75Z",
    fill: "#7C7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.25C20.4142 10.25 20.75 10.5858 20.75 11V22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22V11.2444C3.25 10.8302 3.58579 10.4944 4 10.4944C4.41421 10.4944 4.75 10.8302 4.75 11.2444V21.25H19.25V11C19.25 10.5858 19.5858 10.25 20 10.25Z",
    fill: "#7C7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 2C3.25 1.58579 3.58579 1.25 4 1.25H20C20.4142 1.25 20.75 1.58579 20.75 2V6C20.75 6.41421 20.4142 6.75 20 6.75C19.5858 6.75 19.25 6.41421 19.25 6V2.75H4.75V5.9111C4.75 6.32531 4.41421 6.6611 4 6.6611C3.58579 6.6611 3.25 6.32531 3.25 5.9111V2Z",
    fill: "#7C7B7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 16C8.75 15.5858 9.08579 15.25 9.5 15.25H14.5C14.9142 15.25 15.25 15.5858 15.25 16V22C15.25 22.4142 14.9142 22.75 14.5 22.75H9.5C9.08579 22.75 8.75 22.4142 8.75 22V16ZM10.25 16.75V21.25H13.75V16.75H10.25Z",
    fill: "#7C7B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.18ea9a48b78650253cbbcfeb22cb15e5.svg";
export { ForwardRef as ReactComponent };